const comedorModulo = {
    agGrid: {
        pagination: true,
        pagina: 15,
        id: 'myGrid',
        class: 'ag-theme-alpine',
        style: {
            width: '100%',
            height: '700px'
        }
    },
    agGridModal: {
        paginacion: 10,
        id: 'myGrid',
        class: 'ag-theme-material mt-3',
        style: {
            width: '100%',
            height: '450px'
        }
    },
    titulos: {
        precios: {
          titulo: 'Registro de Precios de alimentos',
          modulo: 'Comedor',
          tituloCardList  : 'Listado de Precios',
          tituloAgregar   : 'Agregar Nuevo Precio de Comida',
          tituloActualizar: 'Actualizar Precio de Comida',
          tituloEliminar  : 'Eliminar Precio de Comida',
        },
        empleados: {
          titulo: 'Registro de Empleados menú diferenciado - Programa Nutricional',
          modulo: 'Comedor',
          tituloCardList  : 'Listado de Empleados',
          tituloAgregar   : 'Agregar Nuevo Empleados',
          tituloActualizar: 'Actualizar Empleados',
          tituloEliminar  : 'Eliminar Empleados',
        }
    },
    url: {
        seguridad: {
            recuperacion: 'usuario/account/reset-password/init',
            changeUser: 'usuario/account/change-password'
        },
        comedor: {
            buscarEmpleado: 'nomina/empleado/', //empleado/{tipo}/{cadId}
            marcacion: 'marcacion-comedor/ticket',
            turno   : 'comedor/turno'
        },
        precios: {
            comedor : 'comedor',
            comidas : 'comedor/comidas/',
            precios : 'comedor/precios/',
            precioId: 'comedor/precios/findById',
        },
        menus: {
            programaNutricional : 'programa-nutricional'
        }
    },
    button: {
        buttonsCss: {
            primary: 'btn btn-primary btn-block',
            secondary: 'btn btn-secondary btn-block',
            success: 'btn btn-success btn-block',
            danger: 'btn btn-danger btn-block',
            warning: 'btn btn-warning btn-block',
            info: 'btn btn-info btn-block',
            light: 'btn btn-light btn-block',
            dark: 'btn btn-dark btn-block',
            primaryOutline: 'btn btn-outline-primary',
            secondaryOutline: 'btn btn-outline-secondary',
            successOutline: 'btn btn-outline-success',
            dangerOutline: 'btn btn-outline-danger',
            warningOutline: 'btn btn-outline-warning',
            infoOutline: 'btn btn-outline-info',
            lightOutline: 'btn btn-outline-light',
            darkOutline: 'btn btn-outline-dark',
            primarylg: 'btn btn-primary btn-lg btn-block',
            successLg: 'btn btn-success btn-lg btn-block',
            dangerLg: 'btn btn-danger btn-lg btn-block',
            warningLg: 'btn btn-warning btn-lg btn-block',
            warningLgFile: 'btn btn-warning btn-lg btn-block btn-file',
        },
        buttonsNombre: {
            editar: 'Editar',
            ver: 'Ver',
            eliminar: 'Eliminar',
            agregar: 'Agregar ',
            guardar: 'Guardar',
            actualizar: 'Actualizar',
            mostrar: 'Mostrar seleccion',
            regresar: 'Regresar',
            continuar: 'Continuar',
            seleccionar: 'Seleccionar',
            procesar: 'Procesar',
            buscar: 'Buscar',
            sustento: 'Sustento',
            validar: 'Validar',
            descargar: 'Descargar',
            descargarRecibo: 'Descargar Recibo Cobros',
            descargarEstado: 'Descargar Estados Docs',
            detalle: 'Ver Ordenes',
            agregarProducto: 'AÃ±adir Productos',
            anadirProducto: 'AÃ±adir',
            limpiar: 'Eliminar todos los productos',
            anular: 'Anular',
            aprobar: 'Aprobar',
        }
    },
    mensajes: {
        errorServicio: 'error..!!',
        desabilitada: 'Opción desabilitada',
        eliminar: '¿Está seguro de que desea eliminar el siguiente elemento?',
        guardar: '¿Está seguro de que desea guardar?',
        actualizar: '¿Está seguro de que desea actualizar el siguiente elemento?',
        datoGuardado: 'Se guardo corectamente..!!',
        guardarParada: 'Esta seguro que desea registrar este evento..??',
        procesar: '¿Esta seguro que desea procesar el siguiente elemento?',
        validar: '¿Esta seguro que desea validar el siguiente elemento?',
        anticipo: 'Se tomara este valor como anticipo.',
        camposObligatorio: 'Los campos tipo transaccion y nÃºmero documento deben estar llenos caso contrario se tomara como anticipo.',
        anular: 'Confirma que desea eliminar el registro seleccionado.',
    },
    colors: {
        verde: 'green',
        azul: 'blue',
        rojo: 'red'
    },
    imagenes: {
        regalo: '<span><img src="../../../assets/image/regalo.png" height="30" width="30"></i></span>',
        item: '<span><img src="../../../assets/image/regalo.png" height="30" width="30"></i></span>'
    }

}

export type ComedorDiccionario = typeof comedorModulo;
export { comedorModulo }